import { render, staticRenderFns } from "./AppNavigation.vue?vue&type=template&id=2d6bb8e0&scoped=true&class=pa-0%20background&"
import script from "./AppNavigation.vue?vue&type=script&lang=js&"
export * from "./AppNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigation.vue?vue&type=style&index=0&id=2d6bb8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6bb8e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6bb8e0')) {
      api.createRecord('2d6bb8e0', component.options)
    } else {
      api.reload('2d6bb8e0', component.options)
    }
    module.hot.accept("./AppNavigation.vue?vue&type=template&id=2d6bb8e0&scoped=true&class=pa-0%20background&", function () {
      api.rerender('2d6bb8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/AppNavigation.vue"
export default component.exports